import $x from '@/utils/$x';

/**
 * 查询兑换码活动列表
 * @param {*} params
 * @returns
 */
export function queryRedeemInfoList(params) {
  return $x.post('/pergamonRedeemActivity/queryRedeemActivityList', params);
}

/**
 * 保存兑换码活动
 * @param {*} params
 * @returns
 */
export function saveRedeemInfo(params) {
  return $x.post('/pergamonRedeemActivity/saveRedeemActivity', params);
}

/**
 * 删除兑换码活动
 * @param {*} params
 * @returns
 */
export function deleteRedeemActivity(params) {
  return $x.post('/pergamonRedeemActivity/deleteRedeemActivity', params);
}

/**
 * 渠道列表
 * @param {*} params
 * @returns
 */
export function queryAllChannelList(params) {
  return $x.post('/v1/litta/channel/getList', params);
}

/**
 * 查询码库列表页数据
 * @param {*} params
 * @returns
 */
export function queryRedeemRecordList(params) {
  return $x.post('/pergamonRedeemRecord/queryRedeemRecordList', params);
}

/**
 * 更新单个兑换码活动
 * @param {*} params
 */
export function updateSingleRedeem(params) {
  return $x.post('/pergamonRedeemActivity/updateRedeemActivity', params);
}

/**
 * 查询单个兑换码活动
 * @param {*} params
 */
export function querySingleRedeem(params) {
  return $x.post('/pergamonRedeemActivity/queryRedeemActivity', params);
}

/**
 * 查询单个兑换码记录
 * @param {*} params
 */
export function queryRedeemRecordInfo(params) {
  return $x.post('/pergamonRedeemRecord/queryRedeemRecordInfo', params);
}

/**
 * 更新状态(失效)
 * @param {*} params
 * @returns
 */
export function updateRedeemRecordStatus(params) {
  return $x.post('/pergamonRedeemRecord/updateRedeemRecordStatus', params);
}

/**
 * 判断是否可以下载
 * @param {*} params
 * @returns
 */
export function queryRedeemRecordConditionModel(params) {
  return $x.get(
    '/pergamonRedeemRecord/queryRedeemRecordConditionModel',
    params,
  );
}

/**
 * 导出excel
 * @param {*} params
 * @returns
 */
export function exportRedeemRecordData(params) {
  return $x.get('/pergamonRedeemActivity/exportRedeemRecordData', params);
}

/**
 * 批量生成一批券码(不和用户进行绑定)
 * @param {*} params
 * @returns
 */
export function generateRedeemRecordInCount(params) {
  return $x.post('/pergamonRedeemRecord/generateRedeemRecordInCount', params);
}

/**
 * 管理后台更新地址和备注
 * @param {*} params
 * @returns
 */
export function updateRedeemRecordInfo(params) {
  return $x.post('/pergamonRedeemRecord/updateRedeemRecordInfo', params);
}

/**
 * 批量导入手机号码绑定序列号
 * @param {*} params
 */
export function batchRedeem(params) {
  return $x.post('/pergamonRedeemRecord/importUserPhoneList', params);
}

/**
 * 当前用户没有兑换并且没有过期的券码
 * @param {*} params
 */
export function queryRedeemByUser(params) {
  return $x.post('/pergamonRedeemRecord/queryRedeemRecordByUser', params);
}

/**
 * 兑换码活动转移
 * @param {*} params
 */
export function transferRedeem(params) {
  return $x.post('/pergamonRedeemRecord/transferRedeemRecord', params);
}

/**
 * 更新活动状态
 * @param {*} params
 * @returns
 */
export function updateRedeemActivityStatus(params) {
  return $x.post('/pergamonRedeemActivity/updateRedeemActivityStatus', params);
}

export function exportRedeemRecordDataOSS(params) {
  return $x.get('/pergamonRedeemRecord/exportRedeemRecordDataOSS', params);
}

/**
 * 渠道ID查询推广渠道
 * @param {*} params
 * @returns
 */
export function getChannelListByParentIds(params) {
  return $x.post('/v1/litta/channel/getChannelListByParentIds', params);
}

/**
 * 查询码库列表页数据(根据code直接查询)
 * @param {*} params
 * @returns
 */
export function queryRedeemRecordByCodeList(params) {
  return $x.post('/pergamonRedeemRecord/queryRedeemRecordByCodeList', params);
}

/**
 * 渠道ID查询推广渠道
 * @param {*} params
 * @returns
 */
 export function queryPergamonPromotionAll(params) {
  return $x.post('/v1/litta/promotion/queryPergamonPromotionAll', params);
}

/**
 * 分页查询兑换码导出任务
 * @param {*} params
 */
 export function queryRedeemExportTasks(params) {
  return $x.post('/pergamonRedeemRecord/queryRedeemExportTasks', params);
}

/**
 * 生成小程序码
 * @param {*} params
 */
 export function generateAppletQrCodes(params) {
  return $x.post('/pergamonRedeemRecord/generateAppletQrCodes', params);
}
/**
 * 自动生成兑换码短链信息(自动区分永久or临时短链) 
 * @param {*} params
 */
 export function autoGenRedeemShortLink(params) {
  return $x.post('/pergamonRedeemRecord/autoGenRedeemShortLink', params);
}
/**
 * 查找兑换码统一域名(使用统一域名进行跳转)
 * @param {*} params
 */
 export function genUniformURL(params) {
  return $x.post('/pergamonRedeemRecord/genUniformURL', params);
}